import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = {
    sseEventSource: null,
    lastEventId: '',
    sseResponseData: null,
    isSseEventSourceClosed: false
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/sse/index.js